import React from 'react';
import type { ReactElement } from 'react';
import { createRendererToString, Text } from '@wix/cli-ui-kit';

interface Logger {
  log: (msg: string | ReactElement) => void;
}

const dateTimeFormat = new Intl.DateTimeFormat([], {
  hour: '2-digit',
  minute: '2-digit',
  second: '2-digit',
  hour12: false,
});

export function createAstroLogger(isPrefixed = true): Logger {
  const renderer = createRendererToString({ stripAnsi: false });
  const log = (msg: string | ReactElement) => {
    if (typeof msg === 'string') {
      // eslint-disable-next-line no-console
      setTimeout(() => console.log(msg), 0);
    } else {
      // eslint-disable-next-line no-console
      setTimeout(() => console.log(renderer.render(msg)), 0);
    }
  };

  const prefixedLog = (msg: string | ReactElement) => {
    const timestamp = dateTimeFormat.format(new Date());
    const log = (
      <Text>
        <Text>{timestamp} </Text>
        <Text skin="info">[wix] </Text>
        <Text>{msg}</Text>
      </Text>
    );

    // eslint-disable-next-line no-console
    console.log(renderer.render(log));
  };

  return isPrefixed ? { log: prefixedLog } : { log };
}
